/**
 * Домены, до которых наши письма не доходят. СПИСОК ПУСТ.
 *
 * ИСТОРИЯ, А НЕ ЗАГОТОВКА ВПРОК.
 *
 * 2026-09-15 замер владельца показал: письма доходят до `yandex.ru` и
 * `gmail.com`, до `mail.ru` - нет. Форма регистрации начала предупреждать о
 * четырёх доменах семейства Mail.ru.
 *
 * 2026-09-16 замер ПЕРЕСНЯТ и отменён. Прежний делался с отправителя
 * замороженного проекта, через Supabase, с другой аутентификацией домена -
 * то есть измерял не наш нынешний контур. С Resend и подтверждённым
 * `efira.live` письма доходят и до `yandex.ru`, и до `mail.ru`; проверено
 * владельцем на настоящих ящиках.
 *
 * ПОЧЕМУ СПИСОК ПУСТ, А НЕ УДАЛЁН ВМЕСТЕ С МЕХАНИЗМОМ. Предупреждение,
 * гонящее человека с основного ящика без причины, стоит воронки: `mail.ru` -
 * массовый домен на нашем рынке. Но доставляемость меняется сама по себе, без
 * единой правки у нас, и в день, когда она изменится, механизм должен
 * включаться одной строкой, а не появляться заново.
 *
 * ЧТО ВКЛЮЧАЕТ ЕГО ОБРАТНО: **реальные жалобы** - письма в поддержку «не
 * пришло» с адресов одного домена, подтверждённые записью в журнале
 * (`scope: "email"`, `messageId` есть, в панели Resend - `bounced` или
 * `delivered` без появления у получателя). Не предположение, не замер на
 * одном ящике и не чужой отправитель: прошлый раз ошибка стоила ровно этого.
 *
 * СПИСОК ЖИВЁТ ЗДЕСЬ, В ОДНОМ МЕСТЕ. `contracts` - общий пакет клиента и
 * сервера: форма регистрации предупреждает по нему, сервер по нему же
 * помечает отправку в журнале полем `riskyDomain`.
 */
export const RISKY_EMAIL_DOMAINS = [];
/** Домен адреса в нижнем регистре. null - адрес не похож на адрес. */
export function emailDomain(email) {
    const at = email.trim().toLowerCase().lastIndexOf('@');
    if (at === -1 || at === email.trim().length - 1) {
        return null;
    }
    return email
        .trim()
        .toLowerCase()
        .slice(at + 1);
}
/**
 * Известен ли домен как проблемный по доставке.
 *
 * `domains` - параметр с умолчанием, а не константа внутри: при пустом списке
 * проверить сам механизм иначе нечем, и «выключено» стало бы неотличимо от
 * «сломано». Продакшен второй аргумент не передаёт никогда.
 */
export function isRiskyEmailDomain(email, domains = RISKY_EMAIL_DOMAINS) {
    const domain = emailDomain(email);
    return domain !== null && domains.includes(domain);
}
/**
 * Текст предупреждения для формы регистрации. null - предупреждать не о чем.
 *
 * Текст живёт рядом со списком по той же причине, по которой тексты ошибок
 * валидации живут рядом со схемами: сообщение, которое нужно собирать в
 * компоненте, рано или поздно разъедется с правилом.
 */
export function deliverabilityWarning(email, domains = RISKY_EMAIL_DOMAINS) {
    const domain = emailDomain(email);
    if (domain === null || !domains.includes(domain)) {
        return null;
    }
    return (`Письма на ${domain} доходят не всегда — этот почтовый сервис отбрасывает ` +
        'часть входящих без уведомления. Надёжнее указать другой адрес: без ' +
        'подтверждения почты войти не получится.');
}
//# sourceMappingURL=deliverability.js.map